import React from 'react';
import { Card, Tag, Badge } from 'antd';
import { GiftOutlined, PercentageOutlined, DollarOutlined, CalendarOutlined } from '@ant-design/icons';
import { RewardType, RewardStatus } from '../../../../types/referral.types';
import { formatRewardValue, getRewardTypeLabel, getRewardStatusLabel } from '../../../../utils/referralUtils';

interface RewardCardProps {
  rewardType: RewardType;
  rewardValue: number;
  status: RewardStatus;
  sourceCode?: string;
  usedByCompany?: string;
  onClick?: () => void;
  selectable?: boolean;
  selected?: boolean;
}

const RewardCard: React.FC<RewardCardProps> = ({
  rewardType,
  rewardValue,
  status,
  sourceCode,
  usedByCompany,
  onClick,
  selectable = false,
  selected = false
}) => {
  const getRewardIcon = () => {
    switch (rewardType) {
      case RewardType.PERCENTAGE_DISCOUNT:
        return <PercentageOutlined style={{ fontSize: 24, color: '#1890ff' }} />;
      case RewardType.FIXED_AMOUNT_DISCOUNT:
        return <DollarOutlined style={{ fontSize: 24, color: '#52c41a' }} />;
      case RewardType.FREE_SUBSCRIPTION_DAYS:
        return <CalendarOutlined style={{ fontSize: 24, color: '#faad14' }} />;
      default:
        return <GiftOutlined style={{ fontSize: 24 }} />;
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case RewardStatus.EARNED:
        return 'success';
      case RewardStatus.USED:
        return 'default';
      case RewardStatus.CANCELLED:
        return 'error';
      default:
        return 'default';
    }
  };

  return (
    <Card
      hoverable={selectable && status === RewardStatus.EARNED}
      onClick={selectable && status === RewardStatus.EARNED ? onClick : undefined}
      style={{
        cursor: selectable && status === RewardStatus.EARNED ? 'pointer' : 'default',
        border: selected ? '2px solid #1890ff' : '1px solid #d9d9d9',
        backgroundColor: selected ? '#e6f7ff' : 'white'
      }}
      className="reward-card"
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {getRewardIcon()}
          <div>
            <div style={{ fontSize: 20, fontWeight: 'bold', color: '#000' }}>
              {formatRewardValue(rewardType, rewardValue)}
            </div>
            <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 4 }}>
              {getRewardTypeLabel(rewardType)}
            </div>
          </div>
        </div>
        <Badge
          status={getStatusColor() as any}
          text={getRewardStatusLabel(status)}
        />
      </div>
      
      {sourceCode && (
        <div style={{ fontSize: 12, color: '#595959', marginTop: 8 }}>
          <strong>Kod:</strong> {sourceCode}
        </div>
      )}
      
      {usedByCompany && (
        <div style={{ fontSize: 12, color: '#595959', marginTop: 4 }}>
          <strong>Davet Edilen:</strong> {usedByCompany}
        </div>
      )}
    </Card>
  );
};

export default RewardCard;

